import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {Dialog, withStyles} from "@material-ui/core";
import * as actions from './store/prepaidBalanceActions';
import PrepaidBalanceList from './PrepaidBalanceList';
import { Redirect } from 'react-router-dom';
import { createHistory } from '../../sc-utilities';
import AppLogoLoading from "../../sc-logo";

const styles = (theme) => ({
    root: {
        height: '100%',
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        },
    },
    history: {
        width: '10rem',
        marginTop: theme.spacing(2.5)
    },
    grid: {
        padding: theme.spacing(2)
    },
    heading: {
        paddingLeft: theme.spacing(7),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(15),
        marginTop: theme.spacing(2),
    },
    heading2: {
        fontSize: '120%',
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(4),
    },
    divider: {
        width: 'auto',
        height: '1px'
    },
    heading3: {
        fontSize: '115%',
        paddingTop: theme.spacing(3),
        fontWeight: 'bold',
        paddingLeft: theme.spacing(12),
        paddingBottom: theme.spacing(3),
    },
    icon: {
        color: '#7485FF',
        width: '2rem',
        paddingTop: theme.spacing(1.5)
    },
    moneyIcon: {
        color: '#7485FF',
        width: '2rem',
        size: '250%',
        fontSize: '250%',
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const Balance = (props) => {
    const { classes, onBalanceList, onBalanceCount, activeAccountID, activeCustomerID, isTab=false } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, AccountID: null, redirectPath: '' });
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(true);

    const findItem = (value) => {
        return (balance ?? []).find(el => el.Unit === value);
    };

    useEffect(() => {
        const getBalanceCount = async () => {
            await onBalanceCount({ ActiveCustomerID: activeCustomerID, ActiveAccountID: activeAccountID })
        };
        const getBalanceList = async () => {
            const result = await onBalanceList({ ActiveCustomerID: activeCustomerID, ActiveAccountID: activeAccountID }) || [];
            setBalance(result);
            setLoading(false);
        }

        if (activeAccountID) {
            getBalanceCount();
            getBalanceList();
        }

        // eslint-disable-next-line
    }, [activeAccountID])

    const redirectHandler = (path, AccountID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, AccountID: AccountID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <>
            {!loading && <div className={classes.root}>
                <PrepaidBalanceList isTab={isTab} redirectHandler={redirectHandler} findItem={findItem} activeAccountID={activeAccountID} />
            </div>}
            {loading && <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={loading}
                PaperProps={{
                    classes: {
                        root: classes.loadingScreen
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>}
        </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID,
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage || 'en',
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onBalanceCount: params => dispatch(actions.fetchPrepaidBalanceCount(params)),
        onBalanceList: params => dispatch(actions.fetchPrepaidBalance(params)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Balance));